import {
  isMindmapNode,
  findMindmapRoot,
  layoutMindmapTree,
  CaptureUpdateAction,
} from "@excalidraw/element";

import { getSelectedElements } from "../scene";

import { register } from "./register";

export const actionReorganizeMindMap = register({
  name: "reorganizeMindMap",
  label: "labels.reorganizeMindMap",
  viewMode: false,
  trackEvent: {
    category: "canvas",
  },
  predicate: (elements, appState) => {
    return appState.mindMapModeEnabled;
  },
  perform(elements, appState, _, app) {
    const selected = getSelectedElements(
      app.scene.getNonDeletedElementsMap(),
      appState,
    );
    if (selected.length === 0) {
      return { captureUpdate: CaptureUpdateAction.NEVER };
    }

    const firstMindmapNode = selected.find((el) => isMindmapNode(el));
    if (!firstMindmapNode) {
      return { captureUpdate: CaptureUpdateAction.NEVER };
    }

    const elementsMap = app.scene.getNonDeletedElementsMap();
    const root = findMindmapRoot(firstMindmapNode, elementsMap);

    layoutMindmapTree(root, elementsMap, app.scene).then(() => {
      app.syncActionResult({
        captureUpdate: CaptureUpdateAction.IMMEDIATELY,
      });
    });

    return {
      captureUpdate: CaptureUpdateAction.EVENTUALLY,
    };
  },
});
